import { useStores } from '../../../app/root/domain/stores/useStores';

export function useLoyaltyTierStore() {
	const { loyaltyTierStore } = useStores();

	return loyaltyTierStore;
}
